import React, { type FC } from "react";
import Modal from "@mui/material/Modal";
import { Fade } from "@mui/material";
import type { CustomModalProps } from "../../type/CustomModal";

 
const CustomModal: FC<CustomModalProps> = ({
  autoClose = false,
  open,
  setOpen,
  children,
}) => {
  React.useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(() => {
        setOpen(false);
      }, 5000); // 5000 ms = 5 seconds

      // Cleanup in case component unmounts
      return () => clearTimeout(timer);
    }
  }, [open]);

  const handleClose = () => setOpen(false);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Fade in={open}>
          <div>{children}</div>
        </Fade>
      </Modal>
    </div>
  );
};

export default CustomModal;
